import { Link } from "react-router-dom";

const Footer = () => {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const navLinks = [
    { href: "#services", label: "Services" },
    { href: "#experience", label: "Notre expérience" },
    { href: "#pourquoi-nous", label: "Pourquoi nous" },
    { href: "#a-propos", label: "À propos" },
    { href: "#contact", label: "Contact" },
  ];

  return (
    <footer className="bg-gray-50 border-t border-gray-200" role="contentinfo">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 md:py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-12">
          {/* Column 1: Company Info */}
          <div>
            <h3 className="font-['Manrope'] font-bold text-lg text-gray-900 mb-4">
              Performance Transmission Sàrl
            </h3>
            <address className="not-italic text-gray-600 space-y-2 text-sm">
              <p>Tolochenaz, VD</p>
              <p>Suisse</p>
              <p className="mt-4">
                <a 
                  href="tel:+41799077501" 
                  className="footer-link hover:text-blue-600"
                  data-testid="footer-phone"
                >
                  +41 79 907 75 01
                </a>
              </p>
              <p>
                <a 
                  href="mailto:compta@performancetransmission.ch" 
                  className="footer-link hover:text-blue-600"
                  data-testid="footer-email"
                >
                  compta@performancetransmission.ch
                </a>
              </p>
            </address>
          </div>

          {/* Column 2: Navigation */}
          <div>
            <h3 className="font-['Manrope'] font-semibold text-gray-900 mb-4">
              Navigation
            </h3>
            <nav aria-label="Navigation du pied de page">
              <ul className="space-y-3">
                {navLinks.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      onClick={(e) => scrollToSection(e, link.href)}
                      className="text-gray-600 hover:text-blue-600 transition-colors text-sm footer-link"
                      data-testid={`footer-nav-${link.href.replace("#", "")}`}
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </div>

          {/* Column 3: Legal */}
          <div>
            <h3 className="font-['Manrope'] font-semibold text-gray-900 mb-4">
              Informations légales
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/mentions-legales"
                  className="text-gray-600 hover:text-blue-600 transition-colors text-sm footer-link"
                  data-testid="footer-mentions-legales"
                >
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link
                  to="/politique-confidentialite"
                  className="text-gray-600 hover:text-blue-600 transition-colors text-sm footer-link"
                  data-testid="footer-politique-confidentialite"
                >
                  Politique de confidentialité
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-sm text-gray-500">
            <p>© 2025 Performance Transmission Sàrl. Tous droits réservés.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
